import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { useMyLeadsCRUDActions } from '@mm/state/actions/MyLeadsCRUDActions';
import {
  MyLeadsCreateAudienceResponse,
  MyLeadsCreateAudienceRequestParams,
} from '@mm/state/interfaces/myLeads';
import { notification } from 'antd';
import AudiencesModel from '@mm/state/model/AudiencesModel';
import { useExportContactsAction } from '../Audiences/ExportContacts/ExportContacts';
import { useHistory } from 'react-router-dom';
import { BotBuilderRoutes } from '../../../../../routes/bot-builder-routes';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import { useSelector } from 'react-redux';
import { snake } from '@mm/state/helpers/converterString';

export const useCreateMyLeadsAudience = (onSuccess?: () => void) => {
  const { createAudience } = useMyLeadsCRUDActions();
  const { openAddAudienceToAutomationModal, closeModal } = useModalActions();

  const onExportSuccess = (name: string) => {
    notification.success({
      message: `Audience ${name} export has been scheduled.`,
    });
    onSuccess?.();
  };
  const exportContacts = useExportContactsAction();
  const history = useHistory();
  const chatbotId = useSelector(activeChatbotIdSelector);

  const onAddToAutomation = (activeAudience: AudiencesModel) => {
    openAddAudienceToAutomationModal({
      activeAudience,
      closeModal,
      usePurchaseLeadsLayout: true,
    });
  };

  const createMyLeadsAudience = async ({
    params,
    withAddToAutomation,
    withExport,
  }: {
    params: MyLeadsCreateAudienceRequestParams;
    withAddToAutomation?: boolean;
    withExport?: boolean;
  }) => {
    const updatedParams = {
      ...snake(params),
      query: params.query,
    };
    const contactsCount =
      (params?.limit || 0) - (params.excludedLeadIds?.length || 0);
    const response: MyLeadsCreateAudienceResponse = await createAudience(
      updatedParams,
    );

    if (response?.audience) {
      const { audience } = response;

      notification.success({
        message: `Audience ${audience.name} has been created.`,
      });

      if (withAddToAutomation) {
        onAddToAutomation(audience);
        return;
      }

      if (withExport) {
        exportContacts(audience.id, contactsCount, () =>
          onExportSuccess(audience.name),
        );
        return;
      }

      history.push(
        BotBuilderRoutes.audiences.getLink({
          chatbotId,
          audienceId: audience.id,
        }),
      );
    }
  };

  return { createMyLeadsAudience };
};
